import { getFontSize } from '../constants/fontSizes';

export const aboutHeadingStyle = {
  color: 'secondary.main',
  fontFamily: 'Lato',
  fontWeight: 400,
  fontSize: getFontSize(24),
  lineHeight: {xs: '25px', md: '30px', lg: '35px', xl: '38px'},
  letterSpacing: '-2%',
};

export const aboutTitleStyle = {
  color: 'secondary.main',
  fontFamily: 'Aurora',
  fontWeight: 700,
  fontSize: getFontSize(82),
  lineHeight: {xs: '40px', md: '60px', lg: '90px', xl: '100px'},
  letterSpacing: '-2%',
};

export const aboutBodyStyle = {
  color: 'secondary.main',
  fontFamily: 'Lato',
  fontWeight: 400,
  fontSize: getFontSize(20),
  lineHeight: {xs: '20px', md: '24px', lg: '28px', xl: '30px'},
  letterSpacing: '-1%',
};

